import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IAllMessagesRepsonse } from "../models/Message";
import apiConfig from "../utils/apiConfig";

export default function useLeadMessages(contactId: String, componentName = "useLeadMessages") {
  const { get, post } = useApiHelper(apiConfig(componentName));
  const queryClient = useQueryClient();
  const staleTime = 1000 * 60; //1 minute

  const leadMessages = useQuery({
    queryKey: ["leadCommunications", contactId],
    queryFn: () => get<IAllMessagesRepsonse>(`/message/${contactId}`),
    staleTime: staleTime,
    refetchInterval: staleTime,
    enabled: !!contactId,
  });

  const sendMessage = useMutation(((message: any) => post("/message", message)), {
    onMutate: () => {
      queryClient.invalidateQueries(["leadCommunications", contactId]);
    },
  });

  const markAsRead = useMutation(((messages: any) => post("/message/read", messages)), {
    onMutate: () => {
      queryClient.invalidateQueries(["leadCommunications", contactId]);
      queryClient.invalidateQueries(["leads"]);
    },
  });

  return {
    leadMessages,
    sendMessage,
    markAsRead
  };
}
